module.exports = __webpack_public_path__ + "img/fiftypercentFall.30333a7b.png";